import { render } from "./DeleteForever.vue?vue&type=template&id=34199019"
import script from "./DeleteForever.vue?vue&type=script&lang=js"
export * from "./DeleteForever.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__